import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, Field, FieldArray } from 'redux-form';
import includes from 'lodash/includes';

import { isRequiredBannerLanguage, namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import LangSwitch from '../../../shared/lang/switch';
import InputField from '../../../shared/form-elements/input';
import { isRequired, isSelected } from '../../../shared/form/validation';
import CheckboxField from '../../../shared/form-elements/checkbox';
import SelectField from '../../../shared/form-elements/select/field';

import { enum as bannerTypes } from '../../../../../../../enums/banner-types';
import { enum as languages } from '../../../../../../../enums/languages';

import dashboard from '../../../../config/dashboard';

function BannerContent({ intl, fields, lang, change, bannerTypeList, bannerCustomContentIdList }) {
	return (
		<div className='banners-content'>
			<div>
				{fields.map((member, index) => {
					const field = fields.get(index);

					const type = field.type[0];

					return (
						<div className='banners-info' key={index}>
							<div>
								<span>{intl('Banner info')}: #{index + 1}</span>
								{(!isRequiredBannerLanguage(lang) || index !== 0) && (
									<button
										className='ui-btn ui-btn-primary banners-button banners-info-btn-remove'
										type='button'
										onClick={() => fields.remove(index)}
									>
										{intl('remove')}
									</button>
								)}
							</div>
							<Field
								className='banners-info-field'
								name={`${member}.type`}
								component={SelectField}
								validate={[isSelected]}
								searchable={false}
								options={bannerTypeList.map((t) => ({ value: t.id, label: t.text }))}
								placeholder={intl('Type')}
							/>
							{type && type.value === bannerTypes.simple && (
								<div>
									<div className='banners-fields-horizontally'>
										<Field
											className='banners-info-field banners-image-field'
											name={`${member}.image`}
											component={InputField}
											placeholder={intl('Image link')}
										/>
										<Link
											className='banners-search'
											to={`/banners/images?langs=${isRequiredBannerLanguage(lang) ? lang : [lang, languages.en]}`}
											target='_blank'
										/>
									</div>
									<Field
										className='banners-info-field'
										name={`${member}.link`}
										parse={value => value || null}
										component={InputField}
										placeholder={intl('Link')}
										onChange={({ target: { value } }) => {
											change(`${member}.blank`, !!value && !includes(value, dashboard.baseURL));
										}}
									/>
									{field.link && (
										<div className='banners-info-field'>
											<Field
												name={`${member}.blank`}
												normalize={Boolean}
												component={CheckboxField}
												placeholder={intl('Is blank')}
											/>
										</div>
									)}
								</div>
							)}
							{type && type.value === bannerTypes.custom && (
								<Field
									className='banners-info-field'
									name={`${member}.contentId`}
									component={SelectField}
									validate={[isSelected]}
									searchable={false}
									options={bannerCustomContentIdList.map((c) => ({ value: c.id, label: c.text }))}
									placeholder={intl('Custom content')}
								/>
							)}
						</div>
					);
				})}
			</div>
			<div className='banners-button-wrapper'>
				<button
					className='ui-btn ui-btn-primary banners-button'
					type='button'
					onClick={() => fields.push({
						type: [{ value: bannerTypes.simple, label: bannerTypes.simple }],
						link: '',
						image: '',
						blank: false
					})}
				>
					{intl('Аdd banner content')}
				</button>
			</div>
		</div>
	);
}

function ContentEditor({ intl, lang, languages, error, formValues, change, ...props }) {
	const isIntervalVisible = formValues && formValues.content && formValues.content[lang].list.length > 1;
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit banner')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<Field
						name='title'
						component={InputField}
						validate={[isRequired]}
						placeholder={intl('Banner title')}
					/>
					<div className='banners-lang-switch clearfix'>
						<LangSwitch
							langs={languages}
							onChangeLang={props.onChangeLang}
						/>
					</div>
					<FieldArray
						name={`content.${lang}.list`}
						component={BannerContent}
						change={change}
						intl={intl}
						lang={lang}
						bannerCustomContentIdList={props.bannerCustomContentIdList}
						bannerTypeList={props.bannerTypeList}
					/>
					{isIntervalVisible && (
						<Field
							name={`content.${lang}.interval`}
							type='number'
							parse={value => value ? +value : null}
							component={InputField}
							placeholder={intl('Banner change time (ms)')}
						/>
					)}
					<div className='banners-buttons'>
						<button className='ui-btn ui-btn-primary'>
							{intl('Save')}
						</button>
						<Link
							className='ui-btn ui-btn-cancel'
							to='/banners/contents'
						>
							{intl('Cancel')}
						</Link>
					</div>
					{error && (
						<div className='banners-error'>
							{intl(error)}
						</div>
					)}
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		lang: selectors.select(state, 'language'),
		// -----------------------------------------
		bannerCustomContentIdList: selectors.getBannerCustomContentIds(state),
		bannerTypeList: selectors.getBannerTypes(state),
		languages: selectors.getTabLangs(state),
		formValues: getFormValues(`${namespace}Form`)(state)
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(ContentEditor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/content/editor/main.js